import { type RefObject, useImperativeHandle } from 'react';

import { useQuickFindInputAnalytics } from './input-analytics';

export type ExternalInputAnalyticsHandle = ReturnType<typeof useQuickFindInputAnalytics>;

export const useExternalInputAnalytics = (
	ref: RefObject<ExternalInputAnalyticsHandle | null> | undefined,
): void => {
	const analytics = useQuickFindInputAnalytics();
	useImperativeHandle(ref, () => analytics, [analytics]);
};
